import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const appName = import.meta.env.VITE_APP_NAME || 'Greenplay';
const defaultDescription =
	import.meta.env.VITE_META_DESCRIPTION || `${appName} web app`;

function replaceBranding(value = '') {
	if (!value || appName === 'Greenplay') {
		return value;
	}

	return value.replace(/Greenplay/gi, appName);
}

export default function withMetaDecorator(
	WrappedComponent, // Actually will be a page
	{ title = '', description = '' },
) {
	return (props) => {
		const [t] = useTranslation('common');
		const translatedTitle = title ? t(title) : appName;
		const translatedDescription = description ? t(description) : defaultDescription;
		const _title = replaceBranding(translatedTitle) || appName;
		const _description =
			replaceBranding(translatedDescription) || defaultDescription;

		return (
			<>
				<Helmet>
					<title>{_title}</title>
					<meta name="description" content={_description} />
					<meta property="og:title" content={_title} />
					<meta property="og:description" content={_description} />
					{/* TODO: Ask for og:image and revisit react-snap */}
					<meta
						property="og:image"
						content="http://euro-travel-example.com/thumbnail.jpg"
					/>
					<meta
						property="og:url"
						content="http://euro-travel-example.com/index.htm"
					/>
				</Helmet>
				<WrappedComponent {...props} />
			</>
		);
	};
}
